import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { InitializableInterface } from './initializable.interface';

/**
 * Public contract of the PWA push-notification service: offering the user the subscribe flow
 * and reacting to the outcome. Extends {@link InitializableInterface} (`isInitialized` +
 * `init()`), which wires up the message/click handlers once the user's stored subscription
 * choice is known.
 */
export interface PwaPushNotificationInterface extends InitializableInterface {
    /** Request notification permission and, if granted, subscribe with the push service. */
    pushNotificationSubscribe(): Observable<boolean>;

    /** Show the subscribe visual guide if the user has not yet been asked. */
    askUserForPushNotificationPermission(): void;
}

export const PwaPushNotificationInstanceToken = new InjectionToken<PwaPushNotificationInterface>(
    'PwaPushNotificationInterface',
);
